import { render, staticRenderFns } from "./merchant_furnish.vue?vue&type=template&id=7654f9af&scoped=true"
import script from "./merchant_furnish.vue?vue&type=script&lang=js"
export * from "./merchant_furnish.vue?vue&type=script&lang=js"
import style0 from "./merchant_furnish.vue?vue&type=style&index=0&id=7654f9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654f9af",
  null
  
)

export default component.exports